<template>
  <div class="service-pro bg-white">
		<div class="service-bg"><img src="/static/img/ServiceOpening.jpg" alt=""></div>
		<div class="service-content">
			<div class="service-card">
				<div class="title-img"><img :src="imgUrlSrc" alt=""></div>
				<div class="subtitle">{{subtitle}}</div>
				<div class="txt" v-if="!isYxg">{{txt}}</div>
				<div class="service-btn" @click="download">立即下载</div>
				<div class="subtitle" v-if="!isYxg">服务2： 关注众赢财富通{{serviceName}}号</div>
				<div class="qr-code" v-if="!isYxg">
					<img :src="qrsrc" alt="" >
					<div class="tips">
						<div class="title">温馨提示：</div>
						<div>
							<div class="content">1.{{messageTitle}}</div>
							<div class="content">2.长按识别关注{{serviceName}}号最新课程一手掌握</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<span hidden>{{order}}</span>
	</div>
</template>
<script>
export default {
	name: 'OrderServiceComplete',
	data: () => ({
		'messageTitle': '',
		'loaded': false,
		'completed': false,
		'qrsrc': null,
		'hasBind': false,
		'isQy': false,
		'serviceName': '企业',
		'isYxg': false,
		'imgUrlSrc': '/static/img/Title.png',
		'subtitle': '服务1：下载众赢财富通最新版app',
		'txt': '独家股票分析课程，从小白到股神更近一步',
		'url': 'http://www.zhongyingtougu.com/version/download/?ADTAG=631.841'
	}),
	computed: {
		qyh() {
			return this.$store.getters.getQyh
		},
		order() {
			if (this.$store.getters.getOrder.syn_cms_status !== 0) {
				this.isYxg = true
				this.url = 'https://yxg-front.zhongyingtougu.com/ldy/download?xueguan_code=yxg_basic'
				this.subtitle = '下载云学馆最新版app'
				if (this.$store.getters.getOrder.cms_zms === 1) {
					this.url = 'https://front.zhongyingtougu.com/ldy/downzmsls'
					this.subtitle = '下载朝暮说最新版app'
				}
				this.imgUrlSrc = '/static/img/TitleZX.png'
			} else {
				this.isYxg = false
				this.url = 'http://www.zhongyingtougu.com/version/download/?ADTAG=631.841'
				this.subtitle = '服务1：下载众赢财富通最新版app'
				this.imgUrlSrc = '/static/img/Title.png'
			}
			return this.$store.getters.getOrder
		}
	},
	created () {
		this.getOrderSimpleDetail(this.$route.params.id)
		if (this.$store.getters.getOrder.syn_cms_status !== 0) {
			this.isYxg = true
			this.url = 'https://yxg-front.zhongyingtougu.com/ldy/download?xueguan_code=yxg_basic'
			this.subtitle = '下载云学馆最新版app'
			this.imgUrlSrc = '/static/img/TitleZX.png'
		} else {
			this.isYxg = false
			this.url = 'http://www.zhongyingtougu.com/version/download/?ADTAG=631.841'
			this.subtitle = '服务1：下载众赢财富通最新版app'
			this.imgUrlSrc = '/static/img/Title.png'
		}
	},
	components: {
	},
	mounted: function () {
		this.setPageTitle('服务开通')
		this.qrsrc = '/static/img/' + this.qyh.qr
		this.getQrCode(this.$route.params['id'], rs => {
			this.isQy = rs['data']['isQy']
			this.qrsrc = rs['data']['url']
			this.hasBind = rs['data']['hasBind']
			if (this.isQy) {
				this.qrsrc = '/static/img/' + this.qyh.qr
				this.serviceName = '企业'
			} else {
				this.serviceName = '服务'
			}
			this.fetchDetail()
		})
		document.querySelector('.service-pro').style.height = window.screen.availHeight + 'px'
	},
	methods: {
		download () {
			window.location.href = this.url
		},
		fetchDetail () {
			this.saveLog()
			this.messageTitle = '长按识别即可关注' + this.serviceName + '号'
			if (this.isInWeixin()) {
				if (this.isPC()) {
					this.messageTitle = '扫描二维码, 关注进入' + this.serviceName + '号'
				} else {
					this.messageTitle = '长按识别即可关注' + this.serviceName + '号'
				}
			} else if (this.isMobile()) {
				this.messageTitle = '已为您开通微信' + this.serviceName + '，请保存二维码后，在微信内长按识别二维码关注进入' + this.serviceName + '号'
			}
			console.log('weixin, pc, mobile', this.isInWeixin(), this.isPC(), this.isMobile())
			this.completed = true
			this.loaded = true
		},
		saveLog () {
			let url = '/api/orders/contracts/complete'
			this.$http.put(url).then(response => {
			}, response => {
			})
		}
	}
}
</script>
<style scoped>
body,html{
  height: 100%;
}
.service-pro {
  height: 100%;
  background: #4168d3;
}
.service-pro .service-bg {
  margin: 0 auto;
  width: 100%;
  max-width: 375px;
}
.service-pro .service-bg img{
  width: 100%;
}

.service-content {
  position: relative;
  top: -28px;
  font-size: 14px;
  margin: 0 12px 28px;
  padding: 0 15px;
  background: #fff;
  border: 3px solid #7fc7fc;
  border-radius: 4px;
}
.service-content .title-img {
  margin: -30px auto 0;
  width: 177px;
}
.service-content .title-img img{
  width: 100%;
}
.service-content .service-btn {
  font-size: 19px;
  font-weight: bold;
  width: 260px;
  text-align: center;
  height: 48px;
  line-height: 48px;
  color: #fff;
  background: #4399ff;
  border-radius: 5px;
  box-shadow: 0 0 5px #4399ff;
  margin: 12px auto 24px;
}
.service-content .service-btn:active {
  background: #078ef2;
}
.service-content .subtitle {
  font-size: 16px;
  font-weight: bold;
  color: #4188d3;
  text-align: center;
  line-height: 22px;
  margin-top: 5px;
}
.service-content .txt {
  color: #666;
  text-align: center;
  line-height: 20px;
  margin-top: 4px;
}
.qr-code {
  background: rgba(222,238,249,.3);
  padding: 8px;
  min-height: 100px;
  margin-top: 11px;
  margin-bottom: 30px;
}
.qr-code img {
  width: 100px;
  float: left;
}
.qr-code .tips {
  margin-left: 116px;
  color: #666;
}
.qr-code .tips .title {
  font-weight: bold;
  line-height: 20px;
  margin-top: 9px;
}
.qr-code .tips .content {
  font-size: 13px;
  line-height: 18px;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// OrderServiceComplete.vue?4f990498